import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Modal, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, integerField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import MultiInput from '../../core/components/MultiInput'
import Icon from '../../core/components/Icon'
import {CreateCampaignAction} from '../models'
import {CREATE_CAMPAIGN_ACTION_UPDATED, sendCreateCampaignAction, loadCampaignStream, updateCreateCampaignAction} from '../actions'
import i18n from '../i18n'
import style from './CreateCampaignModal.less'

function defineFirstPosition(notationScale) {
    const firstNotationScale = notationScale[0]
    const remainingNotationScales = notationScale.slice(1)

    const position = notationScale.slice(1).sort((a, b) => (a && a.position) - (b && b.position)).reduce((result, notationScale) => {
        if (result == (notationScale && notationScale.position)) {
            return ++result
        }
        return result
    }, 1)

    return [{
        ...firstNotationScale,
        position
    },
    ...remainingNotationScales]
}

class CreateCampaignModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, action} = this.props

        const notationScale = defineFirstPosition(action && action.notationScale || [])
        dispatch(updateCreateCampaignAction({notationScale}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.action != this.props.action
            && nextProps.action && nextProps.action.notationScale != (this.props.action && this.props.action.notationScale)
            && nextProps.action && nextProps.action.notationScale && nextProps.action.notationScale.length != (this.props.action && this.props.action.notationScale && this.props.action.notationScale.length)) {
            const {dispatch, action} = nextProps

            const notationScale = defineFirstPosition(action && action.notationScale || [])
            dispatch(updateCreateCampaignAction({notationScale}))
        }
    }

    _sendAction() {
        const {dispatch, onHide} = this.props

        return dispatch(sendCreateCampaignAction()).then(() => {
            return dispatch(loadCampaignStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, action, onHide, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.newCampaign}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='label'
                            label={requiredLabel(i18n.title)}
                            {...form.title()} />
                        <MultiInput inverse
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='question'
                            label={i18n.questions}
                            {...form.questions()} />
                    </form>
                    <h5>{i18n.notationScale} <i>*</i></h5>
                    <ul className={style.notationScaleGroup}>
                        {(action && action.notationScale || []).slice(1).sort((a, b) => a.position - b.position).map((notationScale, index) => (
                            <li key={index}>
                                <a
                                    href=''
                                    className={style.remove}
                                    onClick={(e) => form.notationScale.remove(e, notationScale)}>
                                    <Icon icon='minus' size='xs' />
                                </a>
                                <p>
                                    <span>{notationScale.position}</span>
                                    <span> - {notationScale.label}</span>
                                </p>
                            </li>
                        ))}
                    </ul>
                    <form>
                        <Row>
                            <Col xs={3}>
                                <Input
                                    type='text'
                                    name='position'
                                    placeholder={i18n.notationScalePosition}
                                    {...integerField(form.notationScale.position())} />
                            </Col>
                            <Col xs={9}>
                                <Input
                                    type='text'
                                    name='label'
                                    placeholder={i18n.notationScaleLabel}
                                    {...form.notationScale.label()} />
                            </Col>
                        </Row>
                    </form>
                    <ButtonToolbar>
                        {form.notationScale.isValid() && (
                            <Button
                                bsStyle='link'
                                onClick={(e) => form.notationScale.add(e)}>
                                <Icon icon='plus' size='xs' />
                                <span>{i18n.addNotationScale}</span>
                            </Button>
                        )}
                        <Button
                            bsStyle='link'
                            onClick={(e) => form.notationScale.remove(e)}>
                            <Icon icon='minus' size='xs' />
                            <span>{i18n.remove}</span>
                        </Button>
                    </ButtonToolbar>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendAction() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

CreateCampaignModal = connectForm({
    target: 'action',
    schema: CreateCampaignAction.schema,
    action: CREATE_CAMPAIGN_ACTION_UPDATED
})(CreateCampaignModal)

CreateCampaignModal = connect((state) => ({
    action: state.satisfaction.createCampaignAction
}))(CreateCampaignModal)

export default CreateCampaignModal


// WEBPACK FOOTER //
// ./lib/satisfaction/components/CreateCampaignModal.js